import { IAppState } from '@/types/app';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Cookies from 'js-cookie';

@Module({ namespaced: true, name: 'app' })
export default class App extends VuexModule implements IAppState {
  public isLoading = false;

  public sidebar = {
    opened: !Cookies.get('sidebarClosed'),
    withoutAnimation: false,
  };

  public device = 'desktop';

  public size = Cookies.get('size') || 'medium';

  @Mutation
  private LOADING(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  @Mutation
  private TOGGLE_SIDEBAR() {
    this.sidebar.opened = !this.sidebar.opened;
    this.sidebar.withoutAnimation = false;
    if (this.sidebar.opened) {
      Cookies.remove('sidebarClosed');
    } else {
      Cookies.set('sidebarClosed', 'true');
    }
  }

  @Mutation
  private CLOSE_SIDEBAR() {
    Cookies.set('sidebarClosed', 'true');
    this.sidebar.opened = false;
  }

  @Mutation
  private TOGGLE_DEVICE(device: string) {
    this.device = device;
  }

  @Mutation
  private SET_SIZE(size: string) {
    this.size = size;
    Cookies.set('size', size);
  }

  @Action
  loading(isLoading: boolean) {
    this.LOADING(isLoading);
  }

  @Action
  toggleSideBar() {
    this.TOGGLE_SIDEBAR();
  }

  @Action
  closeSideBar() {
    this.CLOSE_SIDEBAR();
  }

  @Action
  toggleDevice(device: string) {
    this.TOGGLE_DEVICE(device);
  }

  @Action
  setSize(size: string) {
    this.SET_SIZE(size);
  }
}
